<img class="splash-bg" [src]="splashScreenImage">
<div class="branding"><img class="pilot-logo" src="assets/theFoodChecker-logo-col{{ settings.brandingImage }}-withStrap.svg" /></div>
<a class="disclaimer" routerLink="disclaimer">Disclaimer</a>

<a class="enter-btn" routerLink="home">
  <span class="label">Enter</span>
</a>

<div class="powered-by-row">
  <span class="powered-by">Powered by Pi</span>
  <svg class="pi-logo" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 360 360" style="enable-background:new 0 0 360 360;" xml:space="preserve">
    <style type="text/css">
      .st0 {
        fill: #FFFFFF;
      }

      .st1 {
        fill: #3399DA;
      }
    </style>
    <rect x="68.5" y="95" class="st0" width="209" height="172.9" />

    <path class="st1" d="M86,121c28-18,35.5-19,48.5-19s126.5,0,126.5,0v35h-40c0,0-2,16-2,33s3.5,53.5,12,53c6.5-0.4,6-14,6-14l35-1
	    c0,0,2,50-41,50c-62.5,0-45.5-120.5-45.5-120.5L167,137c0,0-1,32-14,69s-30,48-30,48l-23-27c0,0,13.4-7.5,23.5-43.5c7-25,8-46,8-46
	    s-6.5,0.5-13,4c-5.9,3.2-11.5,7.5-11.5,7.5L86,121z M180,6.5C84.2,6.5,6.5,84.2,6.5,180S84.2,353.5,180,353.5S353.5,275.8,353.5,180
	    S275.8,6.5,180,6.5z" />
  </svg>
</div>
